<template>
  <v-dialog
    width="900"
    persistent
    scrollable
    v-model="isOpened"
  >
    <v-form @submit.prevent.native="$canWrite && (save($event))">
      <v-card>
        <v-card-title>
          Commenter une intervention
          <v-spacer />
          <v-btn icon @click="isOpened = false" v-if="!isSaving">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-12" v-if="!hasIntervention">
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-card-text>
        <v-card-text class="pa-5" v-else>
          <v-alert
            :value="true"
            type="error"
            class="mb-2"
            v-if="errors.length"
          >
            Veuillez corriger les erreurs suivantes :
            <ul>
              <li v-for="(error, i) in errors" :key="`error${i}`">
                {{ error }}
              </li>
            </ul>
          </v-alert>
          <update-comment v-model="comment" required autofocus class="pa-3" />
          <update-status v-model="intervention.status.id" :maker-id="intervention.Maker_id" class="pa-3 mt-4" v-if="canChangeStatus" />
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-row no-gutters justify="center" align="center" class="px-3">
            <v-spacer />
            <v-btn text @click="isOpened = false" tabindex="-1" class="mr-4" v-if="!isSaving">Annuler</v-btn>
            <v-btn :disabled="!$canWrite" type="submit" :loading="isSaving" color="primary darken-1">Enregistrer</v-btn>
          </v-row>
        </v-card-actions>

      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

import { mapState } from 'vuex';
import _ from 'lodash';
import UpdateComment from './Update/Comment.vue';
import UpdateStatus from './Update/Status.vue';

export default {
  name: `InterventionAddComment`,
  props: [`intervention`],
  data: () => ({
    isOpened: true,
    isSaving: false,
    errors: [],
    comment: ``,
  }),
  computed: {
    ...mapState(`model/user`, [
      `me`,
      `isAtLeastContributor`,
    ]),
    ...mapState(`model/client`, [
      `isSelfMaker`,
    ]),
    hasIntervention() {
      return this.intervention && this.intervention !== null;
    },
    isSelfIntervention() {
      return this.hasIntervention && this.isSelfMaker && this.intervention.Maker_id === this.intervention.Client_id;
    },
    canChangeStatus() {
      return this.hasIntervention && this.me && (this.me.client.isRoot || this.isSelfIntervention) && (this.me.clientAdmin || this.isAtLeastContributor);
    },
  },
  methods: {
    async save() {
      this.errors = [];
      if (_.trim(this.comment) === ``) { this.errors.push(`Veuillez saisir un commentaire`); }
      if (!this.errors.length) {
        this.isSaving = true;
        const step = await this.$store.dispatch(`model/intervention/addStep`, {
          interventionId: this.intervention.id,
          statusId: this.intervention.status.id,
          comment: this.comment,
        });
        // this.isSaving = false;
        this.$emit(`added`, step);
      }
    },
  },
  beforeMount() {
    if (this.hasIntervention) {
      this.statusId = this.intervention.status.id;
    }
  },
  watch: {
    isOpened(isOpened) {
      if (!isOpened) {
        this.$emit(`close`);
      }
    },
    hasIntervention(hasIntervention) {
      if (hasIntervention) {
        this.statusId = this.intervention.status.id;
      }
    },
  },
  components: {
    UpdateComment,
    UpdateStatus,
  },
};
</script>

<style lang="scss">
</style>
